/* SAF Bundle Builder — vanilla JS, no deps.
   Stages a local "box", shows live subtotal + DealEasy tier nudge (mirrored),
   batches one /cart/add.js request, refreshes the theme cart drawer.
   State persists in sessionStorage and the URL (?sbb=<vid>:<qty>,...). */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var f = format || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return f;
    var value;
    switch (m[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function Builder(root) {
    var self = this;
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    this.storageKey = 'saf-bb-' + this.sectionId;
    this.urlKey = 'sbb';

    var cfgEl = root.querySelector('[data-bb-config]');
    try { this.config = JSON.parse(cfgEl.textContent); } catch (e) { this.config = { tiers: [], unit: 'items', ctaLabel: 'Add to cart' }; }
    this.tiers = (this.config.tiers || []).filter(function (t) { return t.qty > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });
    this.unit = this.config.unit || 'items';

    this.box = new Map(); // variantId(string) -> {qty, price, productId, title, scent, opt2, img, url}
    this.baseCartCount = 0; // items already in the cart before this builder session
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-bb-card]'));
    this.variantIndex = {}; // vid -> details, built from cards

    // parse each card's product JSON + build a variant index
    this.cards.forEach(function (card) {
      var script = card.querySelector('[data-bb-product]');
      var prod;
      try { prod = JSON.parse(script.textContent); } catch (e) { prod = null; }
      card._bbProduct = prod;
      if (!prod) return;
      prod.variants.forEach(function (v) {
        self.variantIndex[String(v.id)] = {
          price: v.price,
          available: v.available,
          productId: prod.id,
          title: prod.title,
          url: prod.url,
          img: v.img || prod.img,
          scent: prod.scentIndex ? v.options[prod.scentIndex - 1] : '',
          opt2: prod.otherIndex ? v.options[prod.otherIndex - 1] : ''
        };
      });
    });

    this.loadState();
    this.wireTabs();
    this.wireCards();
    this.wireCheckout();
    this.renderAllCards();
    this.renderSummary();
    this.refreshCartBase();
  }

  Builder.prototype.refreshCartBase = function () {
    var self = this;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { self.baseCartCount = c.item_count || 0; self.renderSummary(); })
      .catch(function () {});
  };

  Builder.prototype.$all = function (sel) {
    return Array.prototype.slice.call(this.root.querySelectorAll(sel));
  };

  /* ---------- state persistence ---------- */
  Builder.prototype.loadState = function () {
    var self = this;
    // 1) URL (shareable) takes precedence
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get(this.urlKey);
    if (fromUrl) {
      fromUrl.split(',').forEach(function (pair) {
        var bits = pair.split(':');
        var vid = bits[0], qty = parseInt(bits[1], 10);
        if (vid && qty > 0 && self.variantIndex[vid]) {
          self.box.set(vid, Object.assign({ qty: qty }, self.variantIndex[vid]));
        }
      });
      if (self.box.size) return;
    }
    // 2) sessionStorage
    try {
      var raw = sessionStorage.getItem(this.storageKey);
      if (raw) {
        JSON.parse(raw).forEach(function (entry) {
          var vid = String(entry[0]);
          var data = entry[1];
          if (data && data.qty > 0 && self.variantIndex[vid]) {
            self.box.set(vid, Object.assign({ qty: data.qty }, self.variantIndex[vid]));
          }
        });
      }
    } catch (e) { /* ignore */ }
  };

  Builder.prototype.persist = function () {
    var arr = Array.from(this.box.entries());
    try { sessionStorage.setItem(this.storageKey, JSON.stringify(arr)); } catch (e) {}
    var params = new URLSearchParams(window.location.search);
    if (arr.length) {
      params.set(this.urlKey, arr.map(function (e) { return e[0] + ':' + e[1].qty; }).join(','));
    } else {
      params.delete(this.urlKey);
    }
    var qs = params.toString();
    var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  };

  /* ---------- tabs (WAI-ARIA) ---------- */
  Builder.prototype.wireTabs = function () {
    var self = this;
    var tablist = this.root.querySelector('[role="tablist"]');
    if (!tablist) return;
    this.tabs = this.$all('[role="tab"]');
    this.panels = this.$all('[data-bb-panel]');

    this.tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () { self.activateTab(idx, true); });
    });
    tablist.addEventListener('keydown', function (e) {
      var i = self.tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % self.tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + self.tabs.length) % self.tabs.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = self.tabs.length - 1;
      if (n === null) return;
      e.preventDefault();
      self.activateTab(n, true);
      self.tabs[n].focus();
    });

    // restore last tab
    var saved = parseInt(sessionStorage.getItem(this.storageKey + '-tab'), 10);
    if (!isNaN(saved) && this.tabs[saved]) this.activateTab(saved, false);
  };

  Builder.prototype.activateTab = function (i, save) {
    if (!this.tabs) return;
    this.tabs.forEach(function (t, idx) {
      var sel = idx === i;
      t.setAttribute('aria-selected', sel ? 'true' : 'false');
      t.tabIndex = sel ? 0 : -1;
      t.classList.toggle('is-active', sel);
    });
    this.panels.forEach(function (p, idx) { p.hidden = idx !== i; });
    if (save) { try { sessionStorage.setItem(this.storageKey + '-tab', i); } catch (e) {} }
  };

  /* ---------- cards ---------- */
  Builder.prototype.wireCards = function () {
    var self = this;
    this.cards.forEach(function (card) {
      if (!card._bbProduct) return;
      var scentSel = card.querySelector('[data-bb-scent-select]');
      if (scentSel) {
        scentSel.addEventListener('change', function () {
          var opt = scentSel.options[scentSel.selectedIndex];
          var descEl = card.querySelector('[data-bb-scent-desc]');
          if (descEl) descEl.textContent = opt ? (opt.getAttribute('data-desc') || '') : '';
          self.renderCardState(card);
        });
      }
      card.querySelectorAll('input[name^="opt2-"]').forEach(function (inp) {
        inp.addEventListener('change', function () { self.renderCardState(card); });
      });
      var addBtn = card.querySelector('[data-bb-add]');
      if (addBtn) addBtn.addEventListener('click', function () { self.addCurrent(card); });
      var inc = card.querySelector('[data-bb-inc]');
      var dec = card.querySelector('[data-bb-dec]');
      if (inc) inc.addEventListener('click', function () { self.addCurrent(card); });
      if (dec) dec.addEventListener('click', function () { self.changeQty(card, -1); });
    });
  };

  Builder.prototype.resolveVariant = function (card) {
    var prod = card._bbProduct;
    if (!prod) return null;
    var scentSel = card.querySelector('[data-bb-scent-select]');
    var opt2Sel = card.querySelector('input[name^="opt2-"]:checked');
    var scent = scentSel ? scentSel.value : null;
    var opt2 = opt2Sel ? opt2Sel.value : null;
    var variant = prod.variants.find(function (v) {
      var ok = true;
      if (prod.scentIndex) ok = ok && v.options[prod.scentIndex - 1] === scent;
      if (prod.otherIndex) ok = ok && v.options[prod.otherIndex - 1] === opt2;
      return ok;
    });
    if (!variant && prod.variants.length === 1) variant = prod.variants[0];
    return variant || null;
  };

  Builder.prototype.renderCardState = function (card) {
    var prod = card._bbProduct;
    if (!prod) return;
    var scentSel = card.querySelector('[data-bb-scent-select]');
    var scent = scentSel ? scentSel.value : null;

    // update 2nd-option availability for the chosen scent
    if (prod.otherIndex) {
      var firstAvail = null;
      card.querySelectorAll('input[name^="opt2-"]').forEach(function (inp) {
        var avail = prod.variants.some(function (v) {
          return (!prod.scentIndex || v.options[prod.scentIndex - 1] === scent)
            && v.options[prod.otherIndex - 1] === inp.value && v.available;
        });
        inp.disabled = !avail;
        var wrap = inp.closest('.saf-bb-opt2');
        if (wrap) wrap.classList.toggle('is-oos', !avail);
        if (avail && firstAvail === null) firstAvail = inp;
      });
      var checked = card.querySelector('input[name^="opt2-"]:checked');
      if ((!checked || checked.disabled) && firstAvail) firstAvail.checked = true;
    }

    var variant = this.resolveVariant(card);
    var priceEl = card.querySelector('[data-bb-price]');
    if (priceEl) priceEl.textContent = variant ? formatMoney(variant.price, this.moneyFormat) : '—';

    var addBtn = card.querySelector('[data-bb-add]');
    var stepper = card.querySelector('[data-bb-stepper]');
    var qtyEl = card.querySelector('[data-bb-qty]');
    var inBox = variant && this.box.has(String(variant.id)) ? this.box.get(String(variant.id)).qty : 0;

    if (addBtn) addBtn.disabled = !variant || !variant.available;
    if (variant && !variant.available && addBtn) addBtn.textContent = 'Sold out';
    else if (addBtn) addBtn.textContent = 'Add to box';

    if (inBox > 0) {
      if (stepper) stepper.hidden = false;
      if (addBtn) addBtn.hidden = true;
      if (qtyEl) qtyEl.textContent = inBox;
    } else {
      if (stepper) stepper.hidden = true;
      if (addBtn) addBtn.hidden = false;
    }
  };

  Builder.prototype.renderAllCards = function () {
    var self = this;
    this.cards.forEach(function (c) { self.renderCardState(c); });
  };

  Builder.prototype.addCurrent = function (card) {
    var prod = card._bbProduct;
    var variant = this.resolveVariant(card);
    if (!variant || !variant.available) return;
    var vid = String(variant.id);
    var cur = this.box.get(vid);
    var qty = (cur ? cur.qty : 0) + 1;
    this.box.set(vid, {
      qty: qty, price: variant.price, productId: prod.id, title: prod.title,
      scent: prod.scentIndex ? variant.options[prod.scentIndex - 1] : '',
      opt2: prod.otherIndex ? variant.options[prod.otherIndex - 1] : '',
      img: variant.img || prod.img, url: prod.url
    });
    this.persist();
    this.renderCardState(card);
    this.renderSummary();
    this.announce(prod.title + ' added. ' + this.countItems() + ' ' + this.unit + ' in your box.');
  };

  Builder.prototype.changeQty = function (card, delta) {
    var variant = this.resolveVariant(card);
    if (!variant) return;
    var vid = String(variant.id);
    var cur = this.box.get(vid);
    if (!cur) return;
    var qty = cur.qty + delta;
    if (qty <= 0) this.box.delete(vid);
    else { cur.qty = qty; this.box.set(vid, cur); }
    this.persist();
    this.renderCardState(card);
    this.renderSummary();
  };

  Builder.prototype.removeLine = function (vid) {
    this.box.delete(String(vid));
    this.persist();
    this.renderAllCards();
    this.renderSummary();
  };

  Builder.prototype.countItems = function () {
    var n = 0; this.box.forEach(function (it) { n += it.qty; }); return n;
  };
  Builder.prototype.subtotal = function () {
    var s = 0; this.box.forEach(function (it) { s += it.price * it.qty; }); return s;
  };

  /* ---------- summary ---------- */
  Builder.prototype.renderSummary = function () {
    var self = this;
    var count = this.countItems();
    var subtotal = this.subtotal();

    this.$all('[data-bb-subtotal]').forEach(function (el) { el.textContent = formatMoney(subtotal, self.moneyFormat); });
    this.$all('[data-bb-count]').forEach(function (el) { el.textContent = count; });
    this.$all('[data-bb-checkout]').forEach(function (el) { el.disabled = count === 0; });

    var mobilebar = this.root.querySelector('[data-bb-mobilebar]');
    if (mobilebar) mobilebar.hidden = count === 0;

    // line items (sidebar)
    var lines = this.root.querySelector('[data-bb-lines]');
    if (lines) {
      var empty = lines.querySelector('[data-bb-empty]');
      lines.querySelectorAll('.saf-bb__line').forEach(function (n) { n.remove(); });
      if (count === 0) {
        if (empty) empty.hidden = false;
      } else {
        if (empty) empty.hidden = true;
        this.box.forEach(function (it, vid) {
          var row = document.createElement('div');
          row.className = 'saf-bb__line';
          var sub = [it.scent, it.opt2].filter(Boolean).join(' · ');
          row.innerHTML =
            '<img class="saf-bb__line-img" src="' + (it.img || '') + '" alt="" width="40" height="40" loading="lazy">' +
            '<span class="saf-bb__line-main">' +
              '<span class="saf-bb__line-title">' + it.title + '</span>' +
              (sub ? '<span class="saf-bb__line-scent">' + sub + '</span>' : '') +
            '</span>' +
            '<span class="saf-bb__line-qty">×' + it.qty + '</span>' +
            '<button type="button" class="saf-bb__line-remove" aria-label="Remove ' + it.title + '">&times;</button>';
          row.querySelector('.saf-bb__line-remove').addEventListener('click', function () { self.removeLine(vid); });
          lines.appendChild(row);
        });
      }
    }

    // tier progress — count items already in the cart PLUS the current box
    var tierCount = (this.baseCartCount || 0) + count;
    var tierMsg = this.tierMessage(tierCount);
    this.$all('[data-bb-tier-msg]').forEach(function (el) { el.textContent = tierMsg.text; });
    var progress = this.root.querySelector('[data-bb-progress]');
    if (progress) progress.hidden = tierCount === 0 || !this.tiers.length;
    var maxQty = this.tiers.length ? this.tiers[this.tiers.length - 1].qty : 1;
    var fill = this.root.querySelector('[data-bb-fill]');
    if (fill) fill.style.width = Math.min(100, (tierCount / maxQty) * 100) + '%';
    this.$all('[data-bb-tier-badge]').forEach(function (b) {
      var q = parseFloat(b.getAttribute('data-qty'));
      var reached = tierCount >= q;
      if (reached && !b.classList.contains('is-reached')) {
        b.classList.add('is-reached', 'just-reached');
        setTimeout(function () { b.classList.remove('just-reached'); }, 500);
      } else if (!reached) {
        b.classList.remove('is-reached');
      }
    });

    if (tierMsg.announce) this.announce(tierMsg.announce);
  };

  Builder.prototype.tierMessage = function (count) {
    if (!this.tiers.length) return { text: '', fill: 0 };
    var current = null, next = null;
    for (var i = 0; i < this.tiers.length; i++) {
      if (count >= this.tiers[i].qty) current = this.tiers[i];
      else { next = this.tiers[i]; break; }
    }
    var prevQty = current ? current.qty : 0;
    var fill, text, announce = null;
    if (next) {
      var span = next.qty - prevQty;
      fill = span > 0 ? Math.min(100, ((count - prevQty) / span) * 100) : 0;
      var need = next.qty - count;
      var word = need === 1 ? this.unit.replace(/s$/, '') : this.unit;
      if (current) {
        text = 'Unlocked ' + current.label + '. Add ' + need + ' more ' + word + ' for ' + next.label + '.';
      } else {
        text = 'Add ' + need + ' more ' + word + ' to unlock ' + next.label + '.';
      }
    } else {
      fill = 100;
      text = 'Max discount unlocked: ' + current.label + '!';
    }
    if (current && this._lastTier !== current.label) { announce = 'Discount reached: ' + current.label; }
    this._lastTier = current ? current.label : null;
    return { text: text, fill: fill, announce: announce };
  };

  Builder.prototype.announce = function (msg) {
    var el = this.root.querySelector('[data-bb-announce]');
    if (el) { el.textContent = ''; setTimeout(function () { el.textContent = msg; }, 30); }
  };

  /* ---------- checkout (batched) ---------- */
  Builder.prototype.wireCheckout = function () {
    var self = this;
    this.$all('[data-bb-checkout]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.checkout(btn); });
    });
  };

  Builder.prototype.showError = function (msg) {
    var el = this.root.querySelector('[data-bb-error]');
    if (el) { el.textContent = msg; el.hidden = false; }
  };

  Builder.prototype.checkout = function (btn) {
    var self = this;
    var items = Array.from(this.box.entries()).map(function (e) {
      return { id: parseInt(e[0], 10), quantity: e[1].qty };
    });
    if (!items.length) return;

    var errEl = this.root.querySelector('[data-bb-error]');
    if (errEl) errEl.hidden = true;
    var labels = this.$all('[data-bb-checkout]');
    labels.forEach(function (b) { b.disabled = true; b._label = b.textContent; b.textContent = 'Adding…'; });

    // Ask for exactly the sections THIS theme's cart element refreshes,
    // so renderContents never chokes on a missing section.
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sectionIds = (cart && typeof cart.getSectionsToRender === 'function')
      ? cart.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionIds.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add items to cart.');
        // success — clear box, refresh drawer
        self.box.clear();
        self.persist();
        self.renderAllCards();
        self.renderSummary();
        self.refreshCartBase();
        self.announce('Your box was added to the cart.');
        self.openCartWithSections(res.j.sections);
      })
      .catch(function (err) { self.showError(err.message || 'Something went wrong. Please try again.'); })
      .finally(function () {
        labels.forEach(function (b) { b.textContent = b._label || self.config.ctaLabel; });
        self.renderSummary(); // re-sets disabled state based on (now empty) box
      });
  };

  Builder.prototype.openCartWithSections = function (sections) {
    sections = sections || {};
    // Replace the WHOLE cart-drawer section so its is-empty/full state is correct
    // (renderContents only swaps inner HTML and leaves a stale is-empty class,
    // which hides freshly-added items -> blank drawer).
    try {
      var drawerHtml = sections['cart-drawer'];
      var wrap = document.getElementById('shopify-section-cart-drawer');
      if (drawerHtml && wrap) { wrap.outerHTML = drawerHtml; }
    } catch (e) {}
    // Refresh the header cart count bubble
    try {
      var bubbleHtml = sections['cart-icon-bubble'];
      var bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleHtml && bubbleEl) {
        var parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('#cart-icon-bubble');
        if (parsed) bubbleEl.innerHTML = parsed.innerHTML;
      }
    } catch (e) {}
    // Open the (re-created) drawer. The custom element re-upgrades on insertion.
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else if (drawer) drawer.classList.add('animate', 'active');
    } catch (e) {}
  };

  Builder.prototype.manualDrawerRefresh = function (sections) {
    try {
      if (sections) {
        var parse = function (html, sel) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector(sel);
          return node ? node.innerHTML : null;
        };
        if (sections['cart-drawer']) {
          var d = document.getElementById('CartDrawer');
          var html = parse(sections['cart-drawer'], '#CartDrawer');
          if (d && html != null) d.innerHTML = html;
        }
        if (sections['cart-icon-bubble']) {
          var b = document.getElementById('cart-icon-bubble');
          var bhtml = parse(sections['cart-icon-bubble'], '#cart-icon-bubble');
          if (b && bhtml != null) b.innerHTML = bhtml;
        }
      }
    } catch (e) { /* ignore render issues; items are already in the cart */ }
    var drawer = document.querySelector('cart-drawer');
    try {
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else if (drawer) drawer.classList.add('animate', 'active');
    } catch (e) { /* never navigate away — the cart already has the items */ }
  };

  function init() {
    document.querySelectorAll('[data-saf-bb]').forEach(function (root) {
      if (root._bbInit) return;
      root._bbInit = true;
      new Builder(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
